export default "__VITE_ASSET__0399dc44__"